/* storybook-check-ignore */
import { Box, FavoriteButton, Text } from '@opendoor/bricks-next';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

import { PropertyDetailsType } from '../types';
import { PricingTraditional } from './Pricing';

interface PropertySummaryProps {
  property: PropertyDetailsType;
}

export const PropertySummary = ({ property }: PropertySummaryProps) => {
  return (
    <Box tag="hgroup">
      <Box flexDirection="row" justifyContent="space-between" alignItems="flex-start" pb={24}>
        <Text tag="h1" typography="$subheaderLarge">
          <Text
            $largerThanSM={{
              typography: '$subheaderLarge',
            }}
            tag="span"
            typography="$subheaderSmall"
            fontWeight="$medium"
          >
            {property.street},
          </Text>
          <br />
          <Text
            $largerThanSM={{
              typography: '$subheaderLarge',
            }}
            tag="span"
            typography="$subheaderSmall"
            fontWeight="$medium"
            color="$contentTertiary"
          >
            {property.city}, {property.state} {property.zip}
          </Text>
        </Text>
        <Box
          backgroundColor="$backgroundPrimary"
          borderWidth={1}
          borderColor="$borderPrimary"
          borderRadius="$8x"
          paddingHorizontal="$8x"
          paddingVertical="$6x"
        >
          <FavoriteButton
            analyticsName="cosmos-marketplace-pdp-favorite"
            onPress={property.onClickReaction}
            size="large"
            variant="default"
            isFavorited={property.isLiked}
          />
        </Box>
      </Box>
      <Box tag="section">
        <PricingTraditional listPrice={property?.listPrice} />
        <Box flexDirection="row">
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.bedrooms} bds
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
            ·
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.bathrooms} ba
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
            ·
          </Text>
          <Text tag="span" typography="$bodyMedium" color="$contentTertiary">
            {property.sqFtTotalLiving} sqft
          </Text>
          {property?.estimatedMonthlyPayment && (
            <>
              <Text tag="span" typography="$bodyMedium" color="$contentTertiary" mx={8}>
                ·
              </Text>
              <Text tag="p" typography="$bodyMedium" color="$contentTertiary">
                {`${formatCurrency(property?.estimatedMonthlyPayment)}/month est.`}
              </Text>
            </>
          )}
        </Box>
        {!!property?.schoolDistricts?.length && (
          <Box flexDirection="row">
            <Text tag="span" typography="$bodyMedium" color="$contentTertiary" pt="$2x">
              {property.schoolDistricts.join(' & ')}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};
